
import React from 'react';

const FeatureBlock = ({ data }) => {
  const { img, title, description } = data;

  return (
    <div className="feature-block two">
      <div className="inner-box feature-flex">
        <div className="icon">
          <img src={img} alt="icon" />
        </div>

        <div className="feature-content">
          <h5>{title}</h5>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default FeatureBlock;
